export const selectOptionsContactRole = [
  "Title Agent", //
  "Appraiser",
  "Insurance Agent", //
  "Buyer Real Estate Agent",
  "Seller Real Estate Agent",
  "Appraisal Point of Contact", //
  "Property Manager",
  "Non-Guarantor",
  "Tenant",
  "Property Seller",
  "General Contractor",
  "Referral Source",
  "Broker Contact",
  "Surveyor",
  "Inspector",
  "Borrower Counsel",
  "Lender Counsel",
  "Settlement Agent",
];
